import { FC, useCallback, useState } from 'react';
import { Button, Stack, Tooltip } from '@mui/material';
import { Share } from '@mui/icons-material';

interface Props {
  tributeUrl: string;
}

export const ShareButtons: FC<Props> = ({ tributeUrl }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleShare = useCallback((platform: 'facebook' | 'whatsapp') => {
    const url = platform === 'facebook'
      ? `https://www.facebook.com/sharer/sharer.php?u=${tributeUrl}`
      : `https://api.whatsapp.com/send?text=${tributeUrl}`;
    window.open(url, '_blank');
  }, [tributeUrl]);

  const handleCopyLink = useCallback(() => {
    navigator.clipboard.writeText(tributeUrl);
    setTooltipOpen(true);
    setTimeout(() => setTooltipOpen(false), 2000);
  }, [tributeUrl]);

  return (
    <Stack direction="row" justifyContent="center" mt={2} mb={8} flexWrap="wrap" gap={1}>
      <Button
        onClick={() => handleShare('facebook')}
        variant="outlined"
        size="small"
        sx={{
          borderColor: '#1877F2',
          color: '#1877F2',

        }}
      >
        <Share sx={{ width: 16, height: 16, mr: 1 }} />
        Facebook
      </Button>
      <Button
        onClick={() => handleShare('whatsapp')}
        variant="outlined"
        size="small"
        sx={{
          borderColor: '#25D366',
          color: '#25D366',
        }}
      >
        <Share sx={{ width: 16, height: 16, mr: 1 }} />
        WhatsApp
      </Button>
      <Tooltip title="Link copied!" open={tooltipOpen}>
        <Button
          onClick={handleCopyLink}
          variant="outlined"
          size="small"
          sx={{
            borderColor: 'text.secondary',
            color: 'text.secondary',
          }}
        >
          <Share sx={{ width: 16, height: 16, mr: 1 }} />
          Copy Link
        </Button>
      </Tooltip>
    </Stack>
  );
};
